// extracted by mini-css-extract-plugin
module.exports = {"container":"LoadingSpinner_container__176jg","spinner":"LoadingSpinner_spinner__eZ7OA","rotate":"LoadingSpinner_rotate__BoNGV"};